import React, { useState } from "react";
import "./AuthPage.css";
import authVideo from "../../assets/auth-video.mp4";
import wordmark from "../../assets/VaaniDM_Wordmark.png";
import { apiUrl } from "../../config";

const INITIAL = {
  name: "",
  mobile: "",
  organizationName: "",
  email: "",
  password: "",
};

function AuthPage({ onAuthSuccess }) {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState(INITIAL);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [mode, setMode] = useState("auth"); // auth | forgot

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const persistSession = (data) => {
    localStorage.setItem("token", data.token);
    if (data.refreshToken) {
      localStorage.setItem("refreshToken", data.refreshToken);
    }
    localStorage.setItem("user", JSON.stringify(data.user));
    onAuthSuccess(data.user);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setInfo("");
    setLoading(true);

    if (mode === "forgot") {
      try {
        const res = await fetch(apiUrl("/auth/forgot-password"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email: formData.email }),
        });
        const data = await res.json();
        setLoading(false);
        if (!res.ok) {
          setError(data.message || data.error || "Request failed");
          return;
        }
        setInfo(data.message || "Check your email for reset instructions.");
        if (data.devResetUrl) {
          setInfo(`${data.message} Dev reset link: ${data.devResetUrl}`);
        }
      } catch (err) {
        setLoading(false);
        setError("Server error");
        console.error(err);
      }
      return;
    }

    const endpoint = isLogin ? "/auth/login" : "/auth/signup";
    const body = isLogin
      ? { email: formData.email, password: formData.password }
      : {
          name: formData.name,
          mobile: formData.mobile,
          organizationName: formData.organizationName,
          // legacy alias still accepted by API
          business: formData.organizationName,
          email: formData.email,
          password: formData.password,
        };

    try {
      const res = await fetch(apiUrl(endpoint), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      setLoading(false);

      if (!res.ok) {
        setError(data.message || data.error || "Something went wrong");
        return;
      }

      if (data.token && data.user) {
        persistSession(data);
      } else if (!isLogin) {
        setInfo("Signup successful. Please log in.");
        setIsLogin(true);
      }
    } catch (err) {
      setLoading(false);
      setError("Server error");
      console.error(err);
    }
  };

  return (
    <div className="auth-wrapper">
      <video autoPlay muted loop playsInline className="auth-bg-video">
        <source src={authVideo} type="video/mp4" />
      </video>

      <div className="auth-card">
        <img src={wordmark} alt="VaaniDM" className="brand-wordmark" />
        <p className="slogan">Smart Outreach. Made Simple.</p>

        <form className="auth-form" onSubmit={handleSubmit}>
          {mode === "forgot" ? (
            <>
              <p style={{ margin: "0 0 12px", color: "#334", fontSize: 14 }}>
                Enter your account email. We will send reset instructions when email delivery is configured.
              </p>
              <input
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </>
          ) : (
            <>
              {!isLogin && (
                <>
                  <input
                    name="name"
                    placeholder="Full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <input
                    name="mobile"
                    placeholder="Mobile (optional)"
                    value={formData.mobile}
                    onChange={handleChange}
                  />
                  <input
                    name="organizationName"
                    placeholder="Organization name"
                    value={formData.organizationName}
                    onChange={handleChange}
                    required
                  />
                </>
              )}

              <input
                name="email"
                type="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <div className="password-wrapper">
                <input
                  name="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  minLength={isLogin ? undefined : 8}
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? "Hide" : "Show"}
                </span>
              </div>
            </>
          )}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading
              ? "Please wait..."
              : mode === "forgot"
                ? "Send reset link"
                : isLogin
                  ? "Login"
                  : "Sign Up"}
          </button>

          {error && <p style={{ color: "crimson", marginTop: 10 }}>{error}</p>}
          {info && <p style={{ color: "#046A38", marginTop: 10 }}>{info}</p>}
        </form>

        <div className="auth-footer">
          {mode === "auth" && isLogin && (
            <button
              type="button"
              className="forgot-link"
              onClick={() => {
                setMode("forgot");
                setError("");
                setInfo("");
              }}
            >
              Forgot Password?
            </button>
          )}
          <p>
            {mode === "forgot" ? (
              <span
                onClick={() => {
                  setMode("auth");
                  setError("");
                  setInfo("");
                }}
              >
                Back to Login
              </span>
            ) : (
              <>
                {isLogin ? "Don't have an account?" : "Already have an account?"}
                <span
                  onClick={() => {
                    setIsLogin(!isLogin);
                    setError("");
                    setInfo("");
                  }}
                >
                  {isLogin ? " Sign Up" : " Login"}
                </span>
              </>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}

export default AuthPage;
